export default __webpack_public_path__ + "4f478b92aa11bd1f0a93cf43f12767bb.png";